import {createSlice} from "@reduxjs/toolkit"
import { saveMilestoneConfig, getMilestoneConfig } from "../../actions/configuration-setting/ProjectConfigSettingAction"

const initialState = {
    //save milestone configuration
    loading: false,
    saveMilConfig: null,
    error:null,
    success: false, 
    // get milestone configuration
    loading1: false,
    getMilConfig: null,
    error1:null,
    success1: false,
}

const projectConfigSlice =  createSlice({
    name: "general-setting",
    initialState,
    extraReducers: (builder) =>{
        builder
        // save milestone configuration
        .addCase(saveMilestoneConfig.pending, (state) => {
            state.loading =true;
            state.error = null;
            state.success = false;
        })
        .addCase(saveMilestoneConfig.fulfilled, (state, {payload}) => {
            state.loading =false;
            state.saveMilConfig = payload;
            state.success = true;
            state.error = null;
        })
        .addCase(saveMilestoneConfig.rejected,(state, {payload}) => {
            state.loading =false;
            state.error = payload;
            state.success = false;
        })
        // get milestone configuration
        .addCase(getMilestoneConfig.pending, (state) => {
            state.loading1 =true;
            state.error1 = null;
            state.success1 = false;
        })
        .addCase(getMilestoneConfig.fulfilled, (state, {payload}) => {
            state.loading1 =false;
            state.getMilConfig = payload;
            state.success1 = true;
            state.error1 = null;
        })
        .addCase(getMilestoneConfig.rejected,(state, {payload}) => {
            state.loading1 =false;
            state.error1 = payload;
            state.success1 = false;
        })
    }
})

export default projectConfigSlice.reducer;